var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{attrs:{"id":"map"}}),_vm._v(" "),(_vm.showPopup)?_c('GeoNamesPopup',{attrs:{"concordance-word":_vm.concordanceWord,"execute-on-mount":_vm.executeOnMount,"publication-year":_vm.publicationYear},on:{"hidePopup":_vm.hidePopup}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-722ab2dd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GeoNames.vue
// module id = null
// module chunks = 